import React from 'react';

import { SessionAlarmsFlyoutContainer } from './SessionAlarmsFlyout.elements';

import { FilterButtonWithDoropdownItemProps, FilterButtonWithDropdown } from 'common/ui';
import { Flyout } from 'common/ui';
import { sortAlarms } from './helpers/sortAlarms';
import { getDurationBetweenTimestamps } from 'common/helpers/v1';
import { FlyoutItem } from './FlyoutItem';
import { DataLoader } from 'common/components/DataLoader/DataLoader';
import { useSessionAlarmsFlyout } from './hooks/useSessionAlarmsFlyout';
import { useTranslation } from 'react-i18next';
import { convertToZonedTimestamp } from 'common/helpers/dateAndTimeHelpersV2';
import { useMachineInfo } from 'common/pages/fleetV2/providers';

const dropdownItems: Record<string, FilterButtonWithDoropdownItemProps> = {
  'date by ascending': {
    label: 'date by ascending'
  },
  'date by descending': {
    label: 'date by descending'
  },
  'duration by ascending': {
    label: 'duration by ascending'
  },
  'duration by descending': {
    label: 'duration by descending'
  }
};

interface Alarm {
  id: string;
  description: string;
  startTimestamp: string;
  endTimestamp?: string;
  duration: string;
}

interface SessionAlarmsFlyoutProps {
  data: Alarm[] | null;
  show: boolean;
  setShow: (show: boolean) => void; 
}

 export const SessionAlarmsFlyout = ({ show, data, setShow }: SessionAlarmsFlyoutProps): JSX.Element => {
  const { hasMessage, hasError, isLoading, order, setOrder } = useSessionAlarmsFlyout();
  const { t } = useTranslation(['mh']);
  const { timeZone } = useMachineInfo();
  // Updated filterAlarms logic
  const filterAlarms = data && sortAlarms(
    data.map((alarm) => {
      const durationInSeconds = getDurationBetweenTimestamps(alarm.startTimestamp, alarm.endTimestamp);
      return {
        ...alarm,
        startTimestampUTC: new Date(alarm.startTimestamp).toISOString(),
        endTimestampUTC: alarm.endTimestamp ? new Date(alarm.endTimestamp).toISOString() : null,
        startTimestampFormatted: convertToZonedTimestamp(alarm.startTimestamp || '', timeZone, 'P, hh:mm:ss a'),
        endTimestampFormatted: alarm.endTimestamp ? convertToZonedTimestamp(alarm.endTimestamp, timeZone, 'P, hh:mm:ss a') : "-", 
        duration: durationInSeconds || 0, 
      };
    }),
    order as string
  );
    
   const isOpen = show;
   
  const flyoutSettings = {
    handleClose: () => {if (typeof setShow === 'function') setShow?.(false)},
    title: (
      <>
        <h2>{t('session_alarms')}</h2>
        <FilterButtonWithDropdown
          {...{
            selected: order,
            handleSelect: ({ id }: { id?: string }) => id && setOrder(id as string),
            items: dropdownItems
          }}
        >
          {t('sorting_by')}
        </FilterButtonWithDropdown>
      </>
    ),
    isOpen: isOpen ? true : false
  };

  return (
    <Flyout {...flyoutSettings}>
      <SessionAlarmsFlyoutContainer className="flyout-session-salarms">
        <DataLoader {...{ isLoading, hasError, hasMessage }}>
          {filterAlarms && filterAlarms?.map((alarms,i) => {
                    return (
                      <FlyoutItem
                        key={`session${i}`}
                        {...{...alarms}}
                      />
                    );
                  })}
        </DataLoader>
      </SessionAlarmsFlyoutContainer>
    </Flyout>
  );
};

/*export const SessionAlarmsFlyoutV1 = (): JSX.Element => {
  const { order, setOrder } = {};
  const [{ subTab }, handle] = useFleetRouter(); //useRouterWithHandler(`${fleetPageRoute}/sessionId`);
  const isOpen = subTab === 'select-session' ? true : false;
  const { alarms } = useChangeoverSessionDetailsAPI();
  const flyoutSettings = {
    handleClose: () => handle('updatePath', { subTab: 'single-session' }),
    title: (
      <>
        <h2>Select Session</h2>
        <FilterButtonWithDropdown
          {...{
            selected: order,
            handleSelect: ({ id }: { id?: string }) => setOrder(id),
            items: dropdownItems
          }}
        />
      </>
    ),
    isOpen
  };

  return (
    <Flyout {...flyoutSettings}>
      <SessionAlarmsFlyoutContainer className="flyout-select-sessions">
        {alarms?.map((alarm: Record<string, unknown>, i: number) => {
          return <FlyoutItem key={`session${i}`} {...alarm} />;
        })}
      </SessionAlarmsFlyoutContainer>
    </Flyout>
  );
};*/
